import { Component } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import NyugtaLista from './NyugtaLista';
import NapiOsszesitoContent from './NapiOsszesitoContent';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from './NyugtaTooltips';

class NyugtaBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: undefined,
    };
  }

  hasRole = (roles, checkKarb) => {
    return this.props.globals.hasRole(roles, checkKarb);
  }

  componentDidMount() {
    if (this.hasRole(['SZAMLAZAS_NYUGTA'])) this.toggle('2');
    if (this.hasRole(['SZAMLAZAS_NYUGTA'])) this.toggle('1');
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  render() {
    return (
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            {"Nyugták"}
            <CustomTooltip text={getTooltip('nyugtak')} id="nyugtakTT" />
          </div>
          <div className="row" style={ {'padding': 20} }>
            <div className="col-md-12">
              {/* <NyugtaLista {...this.props} globals={this.props.globals} /> */}
                <Nav tabs>
                  {this.hasRole(['SZAMLAZAS_NYUGTA']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => { this.toggle('1'); }}
                      >
                        Nyugták
                        <CustomTooltip text={getTooltip('nyugtak')} id="nyugtakTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {this.hasRole(['SZAMLAZAS_NYUGTA']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '2' })}
                        onClick={() => { this.toggle('2'); }}
                      >
                        Napi összesítő
                        <CustomTooltip text={getTooltip('napiosszesito')} id="napiosszesitoTT" />
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {this.hasRole(['SZAMLAZAS_NYUGTA']) && (
                    <TabPane tabId="1">
                      <NyugtaLista globals={this.props.globals} active={this.state.activeTab === '1'} />
                    </TabPane>
                  )}
                  {this.hasRole(['PARTNER_TORZS']) && (
                    <TabPane tabId="2">
                      <NapiOsszesitoContent globals={this.props.globals} active={this.state.activeTab === '2'} />
                    </TabPane>
                  )}
                </TabContent>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NyugtaBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default NyugtaBase;
